module.exports = __webpack_public_path__ + "static/img/bg-es.47f124d9.png";